import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmd00711-input-form" }
const _hoisted_2 = { class: "column sdfile-name" }
const _hoisted_3 = { class: "q-ml-sm q-mt-xs" }
const _hoisted_4 = { class: "column sdfile-size" }
const _hoisted_5 = { class: "q-ml-sm q-mt-xs" }
const _hoisted_6 = { class: "cmd00711-input-select row q-gutter-x-sm items-end q-mb-lg" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col-1.5 cmd00711-template-button" }
const _hoisted_10 = { class: "cmd00711-item-table q-mb-md" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = {
  class: "col",
  style: {"margin-top":"2px"}
}
const _hoisted_13 = { class: "cmd00711-other-setting-area" }
const _hoisted_14 = { class: "row q-mt-sm" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "row q-mt-sm" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col q-gutter-x-xs flex justify-end" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import axios from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import SystemImportItemCode from '../../common/code/SystemImportItemCode';
import CategorySelects from '../../components/selects/CategorySelects.vue';
import PastSdfileSelects from '../../components/selects/PastSdfileSelects.vue';
import SupplierSelects from '../../components/selects/SupplierSelects.vue';
import SystemItemSelects from '../../components/selects/SystemItemSelects.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';

interface Props {
  // SDFile名
  fileName: string;
}

// アップロードSDFile一覧
interface NameSettingColumn {
  number: number;
  file_item_name: string;
  system_item_name: string;
}

// プルダウン
interface Options {
  label: string;
  value: string;
}

// SDFile項目名
interface SdFileItemName {
  number: number;
  file_item_name: string;
  system_item_code: string;
  error: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00711',
  props: {
    fileName: {}
  },
  setup(__props: any) {

const router = useRouter();
const props = __props;

// SDFファイル名
const fileName = ref('');
// SDファイル名の長さが45文字を超えているかどうか
const isSdfileNameLength = ref(false);
// SDFファイルサイズ
const fileSize = ref('');
// サプライヤ
const supplier = ref('');
// カテゴリー
const category = ref('');
// 過去SDFile
const pastSdfile = ref('');
// 過去SDFileプルダウン
const pastSdfileOptions = ref<Options[]>([]);
// 備考
const memo = ref('');
// 「テンプレートとして登録する」フラグ
const addTempleteFlag = ref(false);

// Dialogタイトル
const dialogTitle = ref('');
// Dialog表示レベル
const dialogLevel = ref('');
// Dialog本文
const dialogText = ref(['']);
// 確認Dialogフラグ
const isConfFlg = ref(false);
// テンプレートDialog表示フラグ
const isTemplateDialogFlg = ref(false);
// 取込項目名0件エラーDialog表示フラグ
const isEmptySdfDialogFlg = ref(false);
// 登録Dialog表示フラグ
const isRegisterDialogFlg = ref(false);

// エラーメッセージ
const errMessage = ref('');
// MessageChip表示フラグ
const isMessageChip = ref(false);

// 項目名設定カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const colums: Array<any> = [
  {
    name: 'number',
    label: '番号',
    align: 'left',
    field: (row: NameSettingColumn) => row.number,
    classes: 'text-right',
  },
  {
    name: 'file_item_name',
    label: 'SDFile項目名',
    align: 'left',
    field: (row: NameSettingColumn) => row.file_item_name,
  },
  {
    name: 'system_item_name',
    label: 'システム取込項目名',
    align: 'left',
    field: (row: NameSettingColumn) => row.system_item_name,
    headerClasses: 'system-input',
  },
];

// テーブルデータ
const rows = ref<SdFileItemName[]>([]);

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * データクリア
 */
const clearData = () => {
  supplier.value = '';
  category.value = '';
  pastSdfile.value = '';
  memo.value = '';
  addTempleteFlag.value = false;
  errMessage.value = '';
  isMessageChip.value = false;
  // システム取込項目名プルダウン初期化
  rows.value.forEach((value, index) => {
    rows.value[index].system_item_code = '';
    rows.value[index].error = false;
  });
};

/**
 * SDFile登録画面に戻る
 */
const backPage = () => {
  router.push({ name: 'sdfileRegist' });
};

/**
 * 登録確認ダイアログ表示
 */
const displayRegisterDialog = () => {
  dialogTitle.value = '登録確認';
  dialogLevel.value = 'information';
  dialogText.value = ['入力された内容で登録します。', 'よろしいですか？'];
  isConfFlg.value = false;
  isRegisterDialogFlg.value = true;
};

/**
 * 登録完了ダイアログ
 */
const completeRegisterDialog = () => {
  dialogTitle.value = '登録完了';
  dialogLevel.value = 'information';
  dialogText.value = ['登録が完了しました。'];
  isConfFlg.value = true;
  isRegisterDialogFlg.value = true;
};

/**
 * 初期表示データ取得
 */
const getInitData = () => {
  // Loading Start
  Loading.show();
  const formData = new FormData();
  formData.append('file_name', props.fileName);
  // 項目名設定の番号
  let number = 1;

  axios
    .post('/cmd007111/init', formData)
    .then((res) => {
      const { common, sdfTempFile } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          fileName.value = sdfTempFile.file_name;
          // 文字数が60文字を超えていたら画面のファイルサイズをSDFile名の下に移動
          if (fileName.value.length >= 60) {
            isSdfileNameLength.value = true;
          }
          fileSize.value = sdfTempFile.file_size;
          // SDFile項目名が0件の場合
          if (sdfTempFile.sdFileNameList.length === 0) {
            // エラーダイアログ表示
            dialogTitle.value = 'ファイル読み込みエラー';
            dialogLevel.value = 'error';
            dialogText.value = [
              'SDFileの形式に誤りがあります。',
              '内容を確認して、再度SDFileをアップロードしてください。',
            ];
            isConfFlg.value = true;
            isEmptySdfDialogFlg.value = true;
          } else {
            // 項目名設定
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            sdfTempFile.sdFileNameList.forEach((value: any) => {
              Object.entries(value).forEach(([key]) => {
                rows.value.push({
                  number,
                  file_item_name: key,
                  system_item_code: '',
                  error: false,
                });
                number += 1;
              });
            });
          }
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // ファイルが存在しない場合
            case DetailResultStatusCode.FILE_NOT_EXIST_ERROR:
              dialogTitle.value = 'ファイル読み込みエラー';
              dialogLevel.value = 'error';
              dialogText.value = [common.message];
              isConfFlg.value = true;
              isEmptySdfDialogFlg.value = true;
              break;

            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * テンプレート読み込み
 */
const readTemplete = () => {
  // Loading Start
  Loading.show();
  // システム取込項目名プルダウンのクリア
  rows.value.forEach((value, index) => {
    rows.value[index].system_item_code = '';
    rows.value[index].error = false;
  });
  const formData = new FormData();
  formData.append('supplier_code', supplier.value);
  formData.append('category_id', category.value);

  axios
    .post('/cmd007111/read-template', formData)
    .then((res) => {
      const { common, mapTemplate } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // テンプレート設定
          Object.entries(mapTemplate).forEach(([key, value]) => {
            rows.value.forEach((item, index) => {
              // SDFile項目名とインポートファイルマップテーブルの項目名が一致した場合
              if (item.file_item_name === value) {
                // システム取込項目名を設定
                rows.value[index].system_item_code = SystemImportItemCode[key];
              }
            });
          });
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // テンプレートが未登録の場合
            case DetailResultStatusCode.TEMPLATE_NOT_EXIST_ERROR:
              // 「テンプレートを登録する」をチェック状態にする
              addTempleteFlag.value = true;
              // 警告ダイアログ表示
              dialogTitle.value = 'テンプレート未登録';
              dialogLevel.value = 'warning';
              dialogText.value = [common.message];
              isConfFlg.value = true;
              isTemplateDialogFlg.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 過去SDFile名取得
 */
const getPastSdfFileName = () => {
  const formData = new FormData();
  formData.append('supplier_code', supplier.value);
  formData.append('category_id', category.value ? category.value : '');

  axios
    .post('/cmd007111/past-sdf-file', formData)
    .then((res) => {
      const { common, pastSdfList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // プルダウン内容を設定
          pastSdfList.forEach((pastSdf: { sup_sdfile_name: string; catalog_id: string }) => {
            pastSdfileOptions.value.push({
              label: pastSdf.sup_sdfile_name,
              value: pastSdf.catalog_id,
            });
          });
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};

/**
 * SDFile登録
 */
const registerSdf = () => {
  // Loading Start
  Loading.show();
  // データリセット
  errMessage.value = '';
  isMessageChip.value = false;
  isRegisterDialogFlg.value = false;
  rows.value.forEach((value, index) => {
    rows.value[index].error = false;
  });

  // 登録データ設定
  const formData = new FormData();
  formData.append('file_name', fileName.value);
  formData.append('supplier_code', supplier.value);
  formData.append('category_id', category.value ? category.value : '');
  rows.value.forEach((value) => {
    formData.append(`item_map[${value.file_item_name}]`, value.system_item_code);
  });
  formData.append('del_catalog_id', pastSdfile.value);
  formData.append('memo', memo.value);
  formData.append('add_templete_flag', addTempleteFlag.value ? '1' : '0');

  axios
    .post('/cmd007111/register-sdf-file', formData)
    .then((res) => {
      const { common, errCodeItems } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 完了ダイアログ表示
          completeRegisterDialog();
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // IDNUMBERが存在しない場合
            case DetailResultStatusCode.IDNUMBER_NOT_EXIST_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システム取込み項目名が重複している場合
            case DetailResultStatusCode.DUPLICATE_SYSTEM_NAME_ERROR:
              // 重複しているシステム取込み項目名プルダウンにエラーを設定
              rows.value.forEach((value, index) => {
                errCodeItems.forEach((code: string) => {
                  if (value.system_item_code === code) {
                    rows.value[index].error = true;
                  }
                });
              });
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      // TOPにスクロール
      setTimeout(() => window.scrollTo({ top: 0 }), 400);
    });
};

/**
 * サプライヤプルダウンの選択値設定
 * @param {string} event プルダウン選択値
 */
const setSupplierValue = (event: string) => {
  // プルダウン選択値を設定
  supplier.value = event;
  // プルダウン初期化
  pastSdfileOptions.value = [];
  pastSdfile.value = '';
  // サプライヤ、カテゴリどちらも入力されている場合、過去SDFile名プルダウン取得
  if (!!supplier.value && !!category.value) {
    getPastSdfFileName();
  }
};

/**
 * カテゴリプルダウンの選択値設定
 * @param {string} event プルダウン選択値
 */
const setCategoryValue = (event: string) => {
  // プルダウン選択値を設定
  category.value = event;
  // プルダウン初期化
  pastSdfileOptions.value = [];
  pastSdfile.value = '';
  // サプライヤ、カテゴリどちらも入力されている場合、過去SDFile名プルダウン取得
  if (!!supplier.value && !!category.value) {
    getPastSdfFileName();
  }
};

/**
 * 初期表示処理
 */
// propsが存在しない場合
if (!props.fileName) {
  // 前画面に遷移
  backPage();
} else {
  // 初期表示データ取得
  getInitData();
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[6] || (_cache[6] = [
        _createTextVNode("SDFile項目確認")
      ])),
      _: 1
    }),
    _createVNode(MessageChip, {
      display: isMessageChip.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createVNode(_component_q_form, {
      greedy: "",
      onSubmit: displayRegisterDialog,
      onReset: clearData,
      onValidationError: resetError
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass('q-mb-md sdfile-area ' + (isSdfileNameLength.value ? 'filename-long' : ''))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _cache[7] || (_cache[7] = _createElementVNode("label", null, "SDFile名", -1)),
              _createElementVNode("span", _hoisted_3, _toDisplayString(fileName.value), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[8] || (_cache[8] = _createElementVNode("label", null, "ファイルサイズ", -1)),
              _createElementVNode("span", _hoisted_5, _toDisplayString(fileSize.value), 1)
            ])
          ], 2),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "requier" }, "サプライヤ名", -1)),
              _createVNode(SupplierSelects, {
                supplier: supplier.value,
                "is-validate": true,
                onSelectSupplier: setSupplierValue
              }, null, 8, ["supplier"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "requier" }, "カテゴリー", -1)),
              _createVNode(CategorySelects, {
                category: category.value,
                "is-validate": true,
                onSelectCategory: setCategoryValue
              }, null, 8, ["category"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_q_btn, {
                color: "primary",
                style: {"width":"200px","height":"40px"},
                class: _normalizeClass(supplier.value && category.value ? '' : 'cmd00711-disabled-btn'),
                label: "テンプレートを読み込む",
                disable: supplier.value && category.value ? false : true,
                onClick: readTemplete
              }, null, 8, ["class", "disable"]),
              (supplier.value && category.value ? false : true)
                ? (_openBlock(), _createBlock(_component_q_tooltip, {
                    key: 0,
                    anchor: "top middle",
                    self: "bottom middle",
                    offset: [15, 15]
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createElementVNode("strong", null, "サプライヤ名とカテゴリーを選択してください", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[13] || (_cache[13] = _createElementVNode("label", {
              class: "text-weight-bold",
              style: {"font-size":"1.1rem"}
            }, "項目名設定", -1)),
            _createElementVNode("div", {
              class: _normalizeClass('chem-table-area ' + (rows.value.length === 0 ? 'table-nodata' : ''))
            }, [
              _createVNode(_component_q_table, {
                rows: rows.value,
                columns: colums,
                "row-key": "number",
                flat: "",
                separator: "cell",
                "hide-pagination": "",
                "rows-per-page-options": [rows.value.length],
                class: "q-mb-xl"
              }, {
                body: _withCtx((cell) => [
                  _createVNode(_component_q_tr, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_td, {
                        key: "number",
                        class: "text-right",
                        style: {"width":"1.5rem"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(cell.row.number), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_td, { key: "file_item_name" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(cell.row.file_item_name), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_td, { style: {"min-width":"280px"} }, {
                        default: _withCtx(() => [
                          _createVNode(SystemItemSelects, {
                            id: cell.row.system_item_code,
                            error: cell.row.error,
                            onSelectItem: ($event: any) => (cell.row.system_item_code = $event)
                          }, null, 8, ["id", "error", "onSelectItem"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["rows", "rows-per-page-options"]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_q_checkbox, {
                    modelValue: addTempleteFlag.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addTempleteFlag).value = $event))
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("テンプレートとして登録する")
                    ])),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[16] || (_cache[16] = _createElementVNode("label", {
              class: "text-weight-bold",
              style: {"font-size":"1.1rem"}
            }, "その他設定", -1)),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[14] || (_cache[14] = _createElementVNode("label", null, "過去SDFile名", -1)),
                _createVNode(PastSdfileSelects, {
                  options: pastSdfileOptions.value,
                  "past-sdf": pastSdfile.value,
                  onSelectPastSdf: _cache[1] || (_cache[1] = ($event: any) => (pastSdfile.value = $event))
                }, null, 8, ["options", "past-sdf"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[15] || (_cache[15] = _createElementVNode("label", null, "備考", -1)),
                _createVNode(_component_q_input, {
                  modelValue: memo.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((memo).value = $event)),
                  outlined: "",
                  dense: "",
                  type: "textarea",
                  counter: "",
                  rows: "2",
                  "bg-color": "white",
                  maxlength: "200",
                  class: "q-pb-none"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
            "button-area": _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_q_btn, {
                  color: "grey-7",
                  outline: "",
                  label: "戻る",
                  style: {"min-width":"120px","background":"var(--q-white) !important"},
                  onClick: backPage
                }),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_q_btn, {
                    type: "submit",
                    color: "primary",
                    style: {"width":"150px"},
                    label: "登録"
                  }),
                  _createVNode(_component_q_btn, {
                    type: "reset",
                    outline: "",
                    style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                    icon: "mdi-eraser",
                    label: "クリア"
                  })
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(AlertDialog, {
      display: isTemplateDialogFlg.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[3] || (_cache[3] = ($event: any) => (isTemplateDialogFlg.value = false)),
      onClose: _cache[4] || (_cache[4] = ($event: any) => (isTemplateDialogFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isEmptySdfDialogFlg.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: backPage,
      onClose: backPage
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isRegisterDialogFlg.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: backPage,
      onConfirm: registerSdf,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (isRegisterDialogFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"])
  ]))
}
}

})